interface User {
    email: string;
    id: string;
    permissions: string[];
}

// Overrides @yipp/cms's auth.global.ts, which matched `to.fullPath` against the route permissions:
// the query string made `/work?theme=x` miss the public `/work` entry and fall back to the `user` role,
// so changing a filter redirected visitors to /login. Matching on `to.path` ignores query and hash.
export default defineNuxtRouteMiddleware(async (to) => {
    try {
        const { session, fetchSession } = useAuth()
        let user_session: { user: User } | null = null

        if (!session.value) {
            user_session = await fetchSession()
        } else {
            user_session = session.value
        }

        const required_role = getRequiredRole(to.path, 'GET', useAppConfig().cms?.routePermissions)

        if (!required_role) {
            console.error('Route not defined')
            return navigateTo('/')
        }
        if (required_role === 'public') return

        if (!user_session?.user) return navigateTo('/login')

        if (!user_session.user.permissions.includes(required_role)) return navigateTo('/no-access')
    } catch (err) {
        console.error(err)
    }
})
